@let isExperianCompany = isExperianCompany$ | async;

@if (user$ | async; as user) {
  @if (companyLogo$ | async; as companyLogo) {
    <div class="anim-wrapper h-100">
      <!-- Navigation items -->
      <div class="p-5 bg-light flex-column justify-content-between h-100 w-100">
        <div>
          <div class="mb-4">
            <img class="image-container" [src]="companyLogo" alt="company-logo" />
          </div>

          <div class="p-3">
            <cp-navigation-item
              icon="dashboard"
              [label]="isExperianCompany ? 'Status' : 'Dashboard'"
              [routerLink]="[paths.platform.DASHBOARD]" />
          </div>
          <div class="p-3">
            <cp-navigation-item
              icon="property"
              [label]="isExperianCompany ? 'Dashboard' : 'Properties'"
              [routerLink]="[paths.platform.PROPERTIES]" />
          </div>
          <div class="p-3" *hasCompanyClientUiSettingsEnabled="showDocumentUploadKey">
            <cp-navigation-item
              icon="document"
              label="Documents"
              [routerLink]="[paths.platform.DOCUMENTS]" />
          </div>
        </div>

        <!-- Bottom section -->
        <div>
          @if (adviserContactDetails$ | async; as adviserContactDetails) {
            <div
              *hasCompanyClientUiSettingsEnabled="showAdvisorPageKey"
              class="bg-primary-100 border-radius-3 py-3 px-4 mb-3 pointer"
              [routerLink]="[
                '/',
                paths.PLATFORM,
                paths.platform.PROFILE,
                paths.platform.profile.ADVISOR,
              ]">
              <div class="text-10 bold-700 mb-3">YOUR ADVISER</div>
              <div class="layout-auto-fr gap-3 align-items-center">
                <button pButton class="p-button p-button-primary medium centered w-100 w-fit">
                  <shared-icon class="fill-light" icon="phone" height="1.5rem" width="1.5rem" />
                </button>
                <div class="bold-700 no-wrap text-ellipsis overflow-hidden">
                  {{ adviserContactDetails.name }}
                </div>
              </div>
            </div>
          }
          <div
            *hasCompanyClientUiSettingsEnabled="showProfilePageKey"
            class="py-3 px-4 border-radius-3 bg-gray-5 layout-auto-fr gap-3 align-items-center pointer"
            [routerLink]="['/', paths.PLATFORM, paths.platform.PROFILE]">
            <button pButton class="p-button medium centered bg-gray-2">
              <shared-icon class="fill-light" icon="person" height="1.5rem" width="1.5rem" />
            </button>

            <div class="bold-700 no-wrap text-ellipsis overflow-hidden">{{ user.fullName }}</div>
          </div>
          <div
            *hasCompanyClientUISettingsDisabled="showProfilePageKey"
            class="py-3 px-4 border-radius-3 bg-gray-5 layout-auto-fr gap-3 align-items-center">
            <div class="p-2 border-radius-3 bg-gray-2">
              <shared-icon class="fill-light" icon="person" height="1.5rem" width="1.5rem" />
            </div>
            <div class="bold-700 no-wrap text-ellipsis overflow-hidden">{{ user.fullName }}</div>
          </div>
        </div>
      </div>
    </div>
  }
}
